module.exports = __webpack_public_path__ + "img/Increase.ece5e54f.png";